module.exports = __webpack_public_path__ + "img/left.b9526c40.svg";